





















































































































































































































































































































































































































import gql from '@/gqlService.coffee'

export default {
    name: 'ConsultantDetail',
    props: 
        consultant_uid: String
    data: ()->
        loading: false
        clt_stat: {}
        stats: @$store.state.stats
        default_stat: {
            positives_count: 0
            negatives_count: 0
            informationneeded_count: 0
            validated_count: 0
            today_recived_count: 0
            today_impossible_count: 0
            today_written_count: 0
            today_published_count: 0
            today_signaled_count: 0
            today_information_needed_count: 0
            seven_day_recived_count: 0
            seven_day_impossible_count: 0
            seven_day_written_count: 0
            seven_day_published_count: 0
            seven_day_signaled_count: 0
            seven_day_information_needed_count: 0
            thirty_day_recived_count: 0
            thirty_day_impossible_count: 0
            thirty_day_written_count: 0
            thirty_day_published_count: 0
            thirty_day_signaled_count: 0
            thirty_day_information_needed_count: 0
        }
    mounted: ()->
        self = @
        if @consultant_uid
            @clt_stat = @stats.reduce((acc, current)->
                    ret = acc
                    if current.consultant_id == self.consultant_uid
                        ret = current
                    return ret
                ,0)
        return
    watch:
        'consultant_uid': (newV, oldV)->
            self = @
            @clt_stat = @stats.reduce((acc, current)->
                ret = acc
                if current.consultant_id == newV
                    ret = current
                return ret
            ,0)
            return
}
